import React from "react";
import { Container, Section, Eyebrow, DisplayHeading, BodyCopy, Reveal } from "@/components/kit";
import TrustGraph from "@/components/TrustGraph";

export default function GraphSection() {
  return (
    <Section id="trust-graph" className="border-t border-line bg-panel-raised/30">
      <Container>
        <div className="max-w-3xl">
          <Reveal>
            <Eyebrow>Signature</Eyebrow>
          </Reveal>
          <DisplayHeading className="mt-6 text-3xl leading-tight sm:text-4xl md:text-5xl">
            See how trust is actually built.
          </DisplayHeading>
          <Reveal i={1}>
            <BodyCopy className="mt-6">
              The Meira Trust Graph connects AI systems, risks, controls, evidence, assessments and
              assurance outcomes in one explainable view. Every claim leads to evidence. Every risk
              leads to a control. Every control leads to proof.
            </BodyCopy>
          </Reveal>
        </div>

        <Reveal i={2} className="mt-10 sm:mt-14">
          <TrustGraph />
        </Reveal>
      </Container>
    </Section>
  );
}
